export default "__VITE_ASSET__7vK6Acsd__"